'use strict';
import React from 'react';
import SideMenu from '../components/sideMenu';
import NavBar from '../components/navBar';
import menuAction from '../actions/menuAction';
import leaveSetAction from '../actions/leaveSetAction';
import leaveSetStore from '../stores/leaveSetStore';
import Loading from '../components/loading';
import HolidayModal from './holidayComponents/holidayModal';
import modalAction from '../actions/modalAction';

class HolidaySetting extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.state = {
            processing: leaveSetStore.getState().processing,
            holiday: leaveSetStore.getState().holiday,
            isHolidayUpdated: leaveSetStore.getState().isHolidayUpdated,
            modalClose: false,
            action: 0,
            title: "",
            index: "",
        }
    }
    static defaultProps = {
        saturdayWork: ["Full Day", "Half Day", "Off Day"],
        mthTxt: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"]
    };
    componentDidMount() {
        menuAction.pageNumber(17);
        leaveSetStore.listen(this.onChange);
        if (!this.state.processing) {
            leaveSetAction.processing(true);
            leaveSetAction.getHoliday();
        }
    }
    componentWillUnmount() {
        leaveSetStore.unlisten(this.onChange);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.isHolidayUpdated && prevState.isHolidayUpdated != this.state.isHolidayUpdated) {
            window.setTimeout(() => {
                window.location.reload();
            }, 3000);
        }
    }
    onChange(state) {
        this.setState({
            processing: state.processing,
            holiday: state.holiday,
            isHolidayUpdated: state.isHolidayUpdated,
        });
    }
    shouldModalClose(data) {
        this.setState({
            modalClose: data
        });
    }
    handleEdit(e) {
        let index = parseInt(e.target.value);

        let holiday = this.state.holiday;
        holiday.saturdayWork = index;
        leaveSetAction.holiday(holiday);
    }
    handleAdd(e) {
        let index = 0;
        let action = 0;
        let title = "Add Holiday";

        this.setState({
            index: index,
            action: action,
            title: title,
            modalClose: true
        });
    }
    handleEventAdd = (e) =>{
        let index = 0;
        let action = 3;
        let title = "Add Event";

        this.setState({
            index: index,
            action: action,
            title: title,
            modalClose: true
        });
    }
    handleSave(e) {
        if (this.state.processing) return;


        //updateholiday;
        if (typeof this.state.holiday.saturdayWork != 'number') {
            modalAction.modalContent({ title: "Warning", content: "Please select Saturday Work" });
            modalAction.modalClose(true);
            return;
        }
        leaveSetAction.processing(true);
        leaveSetAction.updateHoliday(this.state.holiday);

    }
    handleRemove(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        let title = "Remove Holiday";
        let action = 1;
        this.setState({
            index: index,
            action: action,
            title: title,
            modalClose: true
        });
    }
    handleEventRemove = (e) => {
        let index = parseInt(e.target.getAttribute('data-index'));
        let title = "Remove Event";
        let action = 2;
        this.setState({
            index: index,
            action: action,
            title: title,
            modalClose: true
        });
    }
    renderOption() {
        return this.props.saturdayWork.map((sat, index) => {
            return (
                <option value={index} key={index}>{sat}</option>
            )
        });
    }

    renderHoliday() {
        if (!this.state.holiday.holiday) return;

        return this.state.holiday.holiday.map((holiday, index) => {
            let year, month, date;
            year = holiday.year;
            month = holiday.month;
            date = holiday.date;
            let hDate = date + "-" + (this.props.mthTxt[month]) + "-" + year;
            return (
                <div className="col-sm-3" key={index}>
                    <div className="hd-wp">
                        <button className="btn btn-danger btn-xs hd-btn-1" data-index={index} onClick={this.handleRemove}>Remove</button>
                        <div className="hd-title"><b>{holiday.title}</b></div>
                        <div className="hd-date">{hDate}</div>

                    </div>
                </div>
            );
        });
    }
    renderEvent = () => {
        if (!this.state.holiday.event) return;

        return this.state.holiday.event.map((event, index) => {
            let year, month, date;
            year = event.year;
            month = event.month;
            date = event.date;
            let hDate = date + "-" + (this.props.mthTxt[month]) + "-" + year;
            return (
                <div className="col-sm-3" key={index}>
                    <div className="hd-wp">
                        <button className="btn btn-danger btn-xs hd-btn-1" data-index={index} onClick={this.handleEventRemove}>Remove</button>
                        <div className="hd-title"><b>{event.title}</b></div>
                        <div className="hd-date">{hDate}</div>

                    </div>
                </div>
            );
        });
    }
    render() {
        let s = this.state.holiday;
        let modal;
        if (this.state.modalClose) {
            modal = (
                <HolidayModal modalClose={this.state.modalClose} shouldModalClose={this.shouldModalClose}
                    title={this.state.title} action={this.state.action} index={this.state.index} holiday={this.state.holiday} />
            )
        }

        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props} />
                    <SideMenu {...this.props} />
                    <div className=" col-md-10  col-sm-8 us-form">
                        <h4><b>Holiday Management</b></h4>
                        <div className="row">
                            <div className="col-sm-4">
                                <div className="form-group">
                                    <label> Saturday Working</label>
                                    <select className="form-control" id="saturdayWork" onChange={this.handleEdit}
                                        value={typeof s.saturdayWork == 'number' ? s.saturdayWork : ""}>
                                        <option value=""></option>
                                        {this.renderOption()}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="divider"></div>
                            <div className="col-sm-4">
                                <div>
                                    <label className="control-label">Holiday:</label>
                                    <button className="btn btn-default btn-xs jps-add " onClick={this.handleAdd}>Add Holiday</button>
                                </div>
                                <small>Holidays fall on Sunday should change to Monday </small>
                            </div>
                        </div>
                        <div className="row">
                            {this.renderHoliday()}
                        </div>
                        <div className="row">
                            <div className="divider"></div>
                            <div className="col-sm-4">
                                <div>
                                    <label className="control-label">Event:</label>
                                    <button className="btn btn-default btn-xs jps-add " onClick={this.handleEventAdd}>Add Event</button>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {this.renderEvent()}
                        </div>
                        <div className="row">
                            <div className="col-sm-3">
                                <button className="btn btn-default" onClick={this.handleSave}>Save</button>
                            </div>
                        </div>
                    </div>

                </div>
                {modal}
                <Loading processing={this.state.processing} />
            </div>
        );
    }
}

export default HolidaySetting;


// WEBPACK FOOTER //
// ./app/setComponents/holidaySetting.js